/* assets/cart-drawer.js
   ==========================================================
   DRYE — Cart Drawer controller (LINE-based qty + 1 refresh)
   + Shopify Markets native support (no third-party apps)
   ========================================================== */

(function () {
  // ------- Qty queue (per LINE) -------
  var __lineQtyDesired = new Map();   // line -> number
  var __lineQtyInFlight = new Map();  // line -> boolean

  function queueQtyChange(line, qty) {
    if (!line) return;
    line = String(line);

    __lineQtyDesired.set(line, qty);
    if (__lineQtyInFlight.get(line)) return;

    __lineQtyInFlight.set(line, true);

    (async function run() {
      try {
        while (true) {
          var desired = __lineQtyDesired.get(line);
          if (typeof desired !== 'number') break;

          __lineQtyDesired.delete(line);

          // Skicka change utan att refresha varje gång
          await changeQuantityByLine(line, desired, { skipRefresh: true });

          // Om inget nytt kom in under tiden, då är vi klara
          if (!__lineQtyDesired.has(line)) break;
        }

        // EN refresh när allt är färdigt
        await refreshCartSection(isOpen());
      } finally {
        __lineQtyInFlight.delete(line);
      }
    })();
  }

  // ------- Helpers -------
  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }
  function qsa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function getDrawerEl() {
    return qs('cart-drawer.drawer');
  }
  function isOpen() {
    var el = getDrawerEl();
    return !!(el && el.classList.contains('open'));
  }

  function getSectionId() {
    var el = getDrawerEl();
    return el ? el.getAttribute('data-section-id') : null;
  }

  function openBackdrop(open) {
    var bd = qs('.cart-backdrop');
    if (!bd) return;
    bd.classList.toggle('is-open', !!open);

    document.documentElement.classList.toggle('no-scroll', !!open);
    document.body.classList.toggle('no-scroll', !!open);
  }

  function toggleDrawer(open) {
    var el = getDrawerEl();
    if (!el) return;

    var shouldOpen = (typeof open === 'boolean') ? open : !isOpen();
    el.classList.toggle('open', shouldOpen);
    el.setAttribute('aria-hidden', shouldOpen ? 'false' : 'true');
    openBackdrop(shouldOpen);

    // När du öppnar: synca free-ship direkt
    if (shouldOpen) {
      syncFreeShipBar();
    }
  }

  // ------- Free shipping bar (Markets-native) -------
  function updateFreeShippingBar(cartTotalCents) {
    var bar = document.querySelector('[data-free-ship-threshold-cents]');
    if (!bar) return;

    var threshold = parseInt(bar.getAttribute('data-free-ship-threshold-cents') || '0', 10) || 0;
    var remaining = Math.max(threshold - (parseInt(cartTotalCents || 0, 10) || 0), 0);

    var moneyEl = bar.querySelector('[data-free-ship-remaining]');
    if (!moneyEl) return;

    // Markets-aware currency detection
    var currency = 'SEK'; // fallback
    
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
      currency = window.Shopify.currency.active;
    }

    // Format med Intl.NumberFormat (native browser API)
    try {
      var formatted = new Intl.NumberFormat(navigator.language || 'en-US', {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(remaining / 100);
      
      moneyEl.textContent = formatted;
    } catch (e) {
      // Fallback om currency inte stöds
      console.warn('Currency formatting error:', e);
      moneyEl.textContent = (remaining / 100).toFixed(2) + ' ' + currency;
    }

    // Progress bar
    var pct = threshold > 0 ? Math.min(((threshold - remaining) / threshold) * 100, 100) : 0;
    var progressEl = bar.querySelector('[data-free-ship-progress]');
    if (progressEl) progressEl.style.width = pct.toFixed(2) + '%';
  }

  function syncFreeShipBar() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
    return fetch(root.replace(/\/?$/, '/') + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { 
        updateFreeShippingBar(cart.original_total_price);
      })
      .catch(function () {});
  }

  // ------- Cart API helpers -------
  async function refreshCartSection(keepOpen) {
    if (keepOpen === void 0) keepOpen = true;

    var secId = getSectionId();
    if (!secId) return;

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
      ? window.Shopify.routes.root
      : '/';

    var url = root.replace(/\/?$/, '/') + '?sections=' + encodeURIComponent(secId);

    try {
      var res = await fetch(url, { credentials: 'same-origin' });
      if (!res.ok) throw new Error('Section fetch failed');

      var json = await res.json();

      var key = secId;
      if (!json || !json[key]) key = Object.keys(json || {})[0];
      if (!key || !json[key]) return;

      var html = json[key];
      var wrapperId = 'shopify-section-' + key;

      var current = document.getElementById(wrapperId);
      if (!current) return;

      var tmp = document.createElement('div');
      tmp.innerHTML = html;

      var fresh = tmp.querySelector('#' + wrapperId);
      if (!fresh) return;

      current.replaceWith(fresh);

      // Efter refresh: uppdatera free-ship bar
      syncFreeShipBar();

      if (keepOpen) {
        var drawer = getDrawerEl();
        if (drawer) {
          drawer.classList.add('open');
          drawer.setAttribute('aria-hidden', 'false');
          openBackdrop(true);
        }
      }
    } catch (err) {
      console.error('refreshCartSection error', err);
    }
  }

  function changeQuantityByLine(line, qty, opts) {
    opts = opts || {};
    if (!line && line !== 0) return;

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
    return fetch(root.replace(/\/?$/, '/') + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Number(qty) }),
      credentials: 'same-origin'
    })
      .then(function (res) {
        if (!res.ok) throw new Error('change.js failed');
        return res.json();
      })
      .then(function () {
        if (opts.skipRefresh) return;
        return refreshCartSection(isOpen());
      })
      .catch(function (err) {
        console.error('changeQuantityByLine error', err);
      });
  }

  function removeByLine(line) {
    return changeQuantityByLine(line, 0);
  }

  // ------- Event handlers -------
  function onClick(e) {
    var t = e.target;
    if (!(t instanceof Element)) t = t.parentElement;
    if (!t) return;

    // Öppna via trigger
    if (t.closest && t.closest('[data-open="new-cart"]')) {
      e.preventDefault();
      toggleDrawer(true);
      return;
    }

    // Stäng via trigger / X / data-toggle-cart
    if (t.closest && t.closest('[data-close="new-cart"], .close-btn, [data-toggle-cart]')) {
      e.preventDefault();
      toggleDrawer(!isOpen());
      return;
    }

    // Klick på backdrop
    if (t.classList && t.classList.contains('cart-backdrop')) {
      e.preventDefault();
      toggleDrawer(false);
      return;
    }

    // Remove
    var removeBtn = t.closest && t.closest('[data-toggle-cart-remove], .js-remove-item');
    if (removeBtn) {
      e.preventDefault();
      var line = removeBtn.getAttribute('data-line');
      if (line) removeByLine(line);
      return;
    }

    // Qty plus/minus inne i drawer
    var plus = t.closest && t.closest('[data-qty-plus]');
    var minus = t.closest && t.closest('[data-qty-minus]');
    if (plus || minus) {
      e.preventDefault();

      var row = t.closest('[id^="line-item-"][data-line]');
      if (!row) return;

      var input = row.querySelector('input[type="number"]');
      if (!input) return;

      var line2 = row.getAttribute('data-line');
      if (!line2) return;

      var current = parseInt(input.value || '0', 10) || 0;
      var next = current + (plus ? 1 : -1);
      if (next < 0) next = 0;
      if (next === current) return;

      input.value = String(next);
      queueQtyChange(line2, next);
      return;
    }
  }

  function onInputChange(e) {
    var input = e.target;
    if (!(input instanceof HTMLInputElement)) return;
    if (input.type !== 'number') return;
    if (!input.closest('#cart-drawer-form')) return;

    var row = input.closest('[id^="line-item-"][data-line]');
    if (!row) return;

    var line = row.getAttribute('data-line');
    if (!line) return;

    var next = parseInt(input.value || '0', 10) || 0;
    if (next < 0) next = 0;

    clearTimeout(input._deb);
    input._deb = setTimeout(function () {
      queueQtyChange(line, next);
    }, 250);
  }

  function onKeydown(e) {
    if (e.key === 'Escape' && isOpen()) {
      toggleDrawer(false);
    }
  }

  // ------- Init -------
  function init() {
    document.addEventListener('click', onClick);
    document.addEventListener('input', onInputChange);
    document.addEventListener('keydown', onKeydown);

    // Första sync om baren redan finns
    syncFreeShipBar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Globalt API som drye-atc.js använder
  window.DRYE_CartDrawer = {
    open: function () { toggleDrawer(true); },
    close: function () { toggleDrawer(false); },
    refresh: refreshCartSection
  };
})();
